query allBaseballPlayers(
  $first: Int,
  $offset: Int,
  $filter: BaseballPlayerFilter,
  $condition: BaseballPlayerCondition
  ) {
  players: allBaseballPlayers(
      first: $first,
      offset: $offset,
      filter: $filter,
      condition: $condition
    ) {
    nodes {
      playerMappings: baseballPlayerMappingsByIntId {
        nodes {
          extId
          extRef
          feed
          mappingId
          mappingType
          createdAt
          createdBy
          updatedAt
          updatedBy
          playerIndex
          playerTeamMapping: playerTeamMappingsByFeedAndPlayerExtId {
            nodes {
              discriminator
              team: baseballTeamMapping { 
                extRef
              }
            }
          }
        }
      }
      name
      source
      playerId
      playerIndex
    }
    totalCount
  }
}
